<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'CommentsPagination',
    props: {
      'self': Number,
      'last': Number,
      'first': Number,
      'prev': [
        Number,
        Boolean,
      ],
      'next': Number,
      'query': String,
    },
    computed: {
      nextPageDisabled() {
        return this.self === this.last
      },
      prevPageDisabled() {
        return this.self === 1
      },
      lastPageDisabled() {
        return this.self === this.last
      },
    },
    methods: {
      toNext() {
        !this.nextPageDisabled ? this.$emit('changePage', this.next) : false
      },
      toPrev() {
        !this.prevPageDisabled ? this.$emit('changePage', this.prev) : false
      },
      toLast() {
        !this.lastPageDisabled ? this.$emit('changePage', this.last) : false
      },
    },
  }
</script>
